import { getPointerType, type DevicePointerType } from "@otto-ec/global-resources/device";

const deviceProps = $state({ isTouchable: false });

export type DeviceProperties = {
  /**
 *
 */
  isTouchable: boolean;
};

/**
 *
 *
 */
export function useDeviceProperties(): DeviceProperties {
  getPointerType().then((pointerType: DevicePointerType) => {
    deviceProps.isTouchable = pointerType.isTouchable;
  });
  return deviceProps;
}
